/*
 * Seletor de variante (swatch) do card de produto.
 * Ao trocar a variante atualiza a imagem, os preços e o nome da variante do card.
 * Baseado na lógica de compare-card-variant.js.
 */
class ProductCardVariant extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.card = this.closest('.card--product') || this.closest('product-card');
    this.select = this.querySelector('.js-card-variant-select');
    const dataEl = this.querySelector('.js-card-variant-data');

    if (!this.card || !this.select || !dataEl) return;

    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('[ProductCardVariant] Invalid variant data', error);
      return;
    }

    this.currentVariant = this.getVariant(this.select.value);

    this.select.addEventListener('change', () => {
      this.applyVariant(this.getVariant(this.select.value));
    });

    this.updateBuyButton(this.currentVariant);

    this.viewBtn = this.card.querySelector('.button__product-card--view-product');
    if (this.viewBtn) {
      this.viewBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }
  }

  getVariant(variantId) {
    return this.data.variants.find(
      (variant) => variant.id.toString() === variantId.toString()
    );
  }

  applyVariant(variant) {
    if (!variant) return;
    this.currentVariant = variant;
    // this.updateTitle(variant);
    this.updatePrice(variant);
    this.updateBuyButton(variant);
  }

  updateBuyButton(variant) {
    if (!variant) return;

    const viewBtn = this.card.querySelector('.button__product-card--view-product');
    if (viewBtn) {
      try {
        const url = new URL(viewBtn.href, window.location.origin);
        url.searchParams.set('variant', variant.id);
        viewBtn.href = url.toString();
      } catch (error) {
        const base = (viewBtn.getAttribute('href') || '').split('?')[0];
        viewBtn.setAttribute('href', `${base}?variant=${variant.id}`);
      }
      viewBtn.toggleAttribute('disabled', !variant.available);
      viewBtn.classList.toggle('btn--disabled', !variant.available);
    }

    const quickAddBtn = this.card.querySelector('.button__product-card-variant');
    if (quickAddBtn) {
      quickAddBtn.dataset.selectedVariant = variant.id;
    }
  }

  async addToCart() {
    const variant = this.currentVariant;
    if (!variant || !variant.available || !this.viewBtn) return;
    if (this.viewBtn.classList.contains('is-loading')) return;

    this.viewBtn.classList.add('is-loading');
    this.viewBtn.setAttribute('aria-disabled', 'true');

    const formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', 1);

    let sections = 'cart-icon-bubble';
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const sectionId = cartDrawer
        .closest('.shopify-section')
        ?.id.replace('shopify-section-', '');
      if (sectionId) sections += `,${sectionId}`;
    }

    formData.append('sections', sections);
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Erro ao adicionar ao carrinho');
      }

      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && data.sections?.['cart-icon-bubble']) {
        cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
      }

      if (cartDrawer && window.theme.settings.afterAtc === 'drawer') {
        setTimeout(() => cartDrawer.renderContents(data, true), 300);
      }

      this.viewBtn.classList.add('is-success');
    } catch (error) {
      console.error('[ProductCardVariant] Add to cart failed', error);
    } finally {
      this.viewBtn.classList.remove('is-loading');
      this.viewBtn.removeAttribute('aria-disabled');
      setTimeout(() => this.viewBtn.classList.remove('is-success'), 1400);
    }
  }

  // updateTitle(variant) {
  //   const titleEl = this.card.querySelector('.js-card-variant-title');
  //   if (titleEl) titleEl.textContent = variant.title;
  // }

  updatePrice(variant) {
    const box = this.card.querySelector('.card__price-box');
    if (!box) return;

    const saveEl = box.querySelector('.card__price-save');
    const badgeEl = box.querySelector('.card__price-off-badge');
    const imageBadgeEl = this.card.querySelector('.discount-percentage');
    const imageFlagEl = imageBadgeEl?.closest('.discount-flag');
    const wasEl = box.querySelector('.card__price-was');
    const pixEl = box.querySelector('.card__price-pix-value');
    const installmentsEl = box.querySelector('.card__price-installments');

    const onSale = Boolean(variant.onSale && variant.compareAtPrice);

    if (pixEl) pixEl.innerHTML = variant.pixPrice;

    if (installmentsEl && variant.installmentsMax && variant.installmentPrice) {
      installmentsEl.innerHTML = `ou <strong class="card__price-current">${variant.price}</strong> em até ${variant.installmentsMax}x de ${variant.installmentPrice} s/juros`;
    } else {
      const currentEl = box.querySelector('.card__price-current');
      if (currentEl) currentEl.innerHTML = variant.price;
    }

    if (saveEl) {
      if (onSale && variant.savings) {
        saveEl.innerHTML = `Economize ${variant.savings}`;
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    if (badgeEl) {
      if (onSale && variant.discountPercent > 0) {
        badgeEl.textContent = `${variant.discountPercent}% OFF`;
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
      }
    }

    if (imageBadgeEl && imageFlagEl) {
      if (onSale && variant.discountPercent > 0) {
        imageBadgeEl.textContent = `${variant.discountPercent}% OFF`;
        imageFlagEl.hidden = false;
      } else {
        imageFlagEl.hidden = true;
      }
    }

    if (wasEl) {
      if (onSale) {
        wasEl.innerHTML = variant.compareAtPrice;
        wasEl.hidden = false;
      } else {
        wasEl.hidden = true;
      }
    }

    box.classList.toggle('card__price-box--sold-out', !variant.available);
  }
}

if (!customElements.get('product-card-variant')) {
  customElements.define('product-card-variant', ProductCardVariant);
}
